import axios from '@/axiosInstance'
import {PaginationParams, ResponseType} from '@/types'

// location queries
export type HttpGetCountriesOptions = {
    search?: string
} & PaginationParams

export const httpGetCountries = (params: HttpGetCountriesOptions) => {
    return axios.get(`/countries`, {params})
}

export type HttpGetProvincesOptions = {
    search?: string
} & PaginationParams

export const httpGetProvinces = (params: HttpGetProvincesOptions) => {
    return axios.get(`/provinces`, {params})
}

export type HttpGetCitiesOptions = {
    search?: string
    province?: string
    responseType: ResponseType
} & PaginationParams

export const httpGetCities = (params: HttpGetCitiesOptions) => {
    return axios.get(`/cities`, {params})
}

// asl queries
export interface HttpGetAslByCoordinatesOptions {
    latitude?: string
    longitude?: string
    responseType: ResponseType
}

export const httpGetAslByCoordinates = (params: HttpGetAslByCoordinatesOptions) =>
    axios.get(`/asl-districts/show-by-coordinates`, {params})

export type HttpGetAslByCityOptions = {
    cityId: string
    search?: string
    responseType: ResponseType
} & PaginationParams

export const httpGetAslByCity = (params: HttpGetAslByCityOptions) => axios.get(`/asl-districts/index-by-city`, {params})

// district queries
export type HttpGetDistrictsOptions = {
    search?: string
    province?: string
    responseType: ResponseType
} & PaginationParams

export const httpGetDistricts = (params: HttpGetDistrictsOptions) => axios.get(`/asl-districts`, {params})

// municipality query by coordinates
export interface HttpMunicipalityByCoordinatesOptions {
    latitude?: string
    longitude?: string
}

export const httpGetMunicipalityByCoordinates = (params: HttpMunicipalityByCoordinatesOptions) =>
    axios.get(`/municipalities/show-by-coordinates`, {params})

// district queries
export type HttpGetMunicipalitiesOptions = {
    search?: string
} & PaginationParams

export const httpGetMunicipalities = (params: HttpGetMunicipalitiesOptions) => axios.get(`/municipalities`, {params})

// Upload user document
export type HttpUploadDocumentPayload = {
    file: FormData
}

export const httpUploadDocument = (payload: FormData) =>
    axios.post('attachments', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

// Delete user document
export type HttpDeleteDocument = {
    urlParams: {
        documentId: string
    }
}
export const httpDeleteDocument = ({urlParams}: HttpDeleteDocument) =>
    axios.delete(`attachments/${urlParams.documentId}`)
